import React from 'react';
import { useSelector } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSingleColumn, NamedLink } from '../../components';
import CtDeliveryChecker from '../../components/CtDeliveryChecker/CtDeliveryChecker';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import ct from '../LandingPage/CtSections/CtSections.module.css';
import css from './DeliveryChecklistPage.module.css';

/**
 * Container delivery checklist: /container-delivery-checklist
 * Public guide to truck access, clearance and site prep, built around CtDeliveryChecker.
 */
const DeliveryChecklistPage = () => {
  const scrollingDisabled = useSelector(isScrollingDisabled);
  return (
    <Page
      title="Shipping Container Delivery Checklist: Clearance & Site Prep | Container Trader"
      description="How much room does a container delivery truck need? Check straight-line clearance, path width, overhead clearance and site prep for 20', 40' and 45' containers."
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <section className={css.hero} aria-labelledby="delivery-checklist-title">
          <div className={ct.inner}>
            <nav aria-label="Breadcrumb" className={css.breadcrumb}>
              <NamedLink name="LandingPage">Home</NamedLink>
              <span aria-hidden="true">/</span>
              <span aria-current="page">Delivery checklist</span>
            </nav>
            <h1 id="delivery-checklist-title" className={css.title}>
              Will a container fit at your site?
            </h1>
            <p className={css.lead}>
              Pick a size, condition and ground type to see the truck, clearance and prep your
              delivery needs.
            </p>
          </div>
        </section>
        <section className={css.body}>
          <div className={ct.inner}>
            <CtDeliveryChecker idPrefix="delivery-checklist" />
          </div>
        </section>
      </LayoutSingleColumn>
    </Page>
  );
};

export default DeliveryChecklistPage;
